{{data.title}}
<div class="confirmation-dialog-divider" *ngIf="data.message"></div>
<p [innerHTML]="data.message" class="message"></p>
<div mat-dialog-actions>
    <button mat-button (click)="close()" *ngIf="data.buttonText.cancelButtonText">{{data.buttonText.cancelButtonText}}</button>
    <button mat-button (click)="success()">{{data.buttonText.confirmButtonText}}</button>
</div>